// services/buyAndSellService.ts
import axios from "axios";
import { BACKEND_URL } from "../utils/api";
import { Sale } from "../utils/database";

interface GetSalesResponse {
  sales: Sale[];
  total: number;
  skip: number;
  limit: number;
}

interface ApiResponse<T> {
  statusCode: number;
  message: string;
  data: T;
}

export const salesService = {
  /**
   * Récupérer toutes les ventes disponibles (avec pagination)
   * GET /buy-and-sell/available?skip=&limit=
   */
  async getSales(token: string, limit: number = 50, skip: number = 0): Promise<GetSalesResponse> {
    try {
      const response = await axios.get<ApiResponse<GetSalesResponse>>(
        `${BACKEND_URL}/buy-and-sell/all-sellings?skip=${skip}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching sales:", error);
      throw error;
    }
  },

  /**
   * Récupérer une vente par ID
   * GET /buy-and-sell/{saleId}
   */
  async getSaleById(token: string, saleId: string): Promise<Sale | null> {
    try {
      const response = await axios.get<ApiResponse<Sale>>(`${BACKEND_URL}/buy-and-sell/${saleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data || null;
    } catch (error) {
      console.error("Error fetching sale by ID:", error);
      throw error;
    }
  },

  async changeSaleStatus(
    token: string,
    saleId: string,
    data: {
      status: Sale["status"];
      note?: string;
    }
  ): Promise<any> {
    try {
      const response = await axios.patch(
        `${BACKEND_URL}/buy-and-sell/admin/${saleId}/status`,
        {
          status: data.status,
          note: data.note,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
